module.exports = __webpack_public_path__ + "static/media/Paw5_o_2c.1d7f0b52.svg";